<template>
  <span 
    class="status-badge" 
    :style="badgeStyle"
    :title="statusLabel"
  >
    <i class="status-icon" :class="statusIcon"></i>
    <span class="status-text">{{ statusLabel }}</span>
  </span>
</template>

<script>
import { getStatusColor, getStatusBgColor, getStatusIcon, getStatusLabel } from '@/shared/workflowHistoryUtils';

export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      required: true,
      validator: (value) => {
        return ['completed', 'failed', 'errored', 'timeout', 'running', 'pending', 'paused', 'killed', 'skipped'].includes(value);
      }
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => {
        return ['small', 'medium', 'large'].includes(value);
      }
    }
  },
  computed: {
    statusIcon() {
      return getStatusIcon(this.status);
    },
    statusLabel() {
      return getStatusLabel(this.status);
    },
    badgeStyle() {
      const textColor = getStatusColor(this.status);
      const bgColor = getStatusBgColor(this.status);
      
      const sizes = {
        small: { padding: '2px 6px', fontSize: '11px' },
        medium: { padding: '4px 10px', fontSize: '13px' },
        large: { padding: '6px 14px', fontSize: '15px' }
      };
      
      return {
        color: textColor,
        backgroundColor: bgColor,
        border: `1px solid ${textColor}`,
        ...sizes[this.size]
      };
    }
  }
};
</script>

<style scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  font-weight: 600;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.status-icon {
  font-size: 1em;
  line-height: 1;
}

.status-text {
  line-height: 1;
}
</style>
